export const apiActionChooser = async (host, v1Action, v2Action) => {
  const useV2Api = true;

  // if (host && v2Hosts.includes(host)) {
  //   useV2Api = true;
  // }

  if (useV2Api) {
    // console.log('Calling V2 API');
    await v2Action();
  } else {
    // console.warn('Calling V1 API');
    await v1Action();
  }
};

export const isHostAllowedForV2 = () => {
  return true;
  // const hostName = DomainConfig.getHost();
  // return v2Hosts.includes(hostName);
};
